module.exports = __webpack_public_path__ + "static/tad-calcara-f3101f987f7b01e6732b6ee204ae9d9a.jpg";